<script lang="ts">
  import CalendarIcon from '@lucide/svelte/icons/calendar';
  import type { DateValue } from '@internationalized/date';
  import { Button } from '$lib/components/ui/button';
  import { Calendar } from '$lib/components/ui/calendar';
  import * as Popover from '$lib/components/ui/popover';
  import { cn } from '$lib/utils';
  import { formatDate } from '$lib/dates';

  type Props = {
    value: DateValue;
    onValueChange: (v: DateValue) => void;
    label: string;
    minValue?: DateValue;
    locale?: string;
    portalTarget?: HTMLElement | null;
  };

  let {
    value,
    onValueChange,
    label,
    minValue,
    locale = 'fr-FR',
    portalTarget = null,
  }: Props = $props();

  let open = $state(false);

  function handleChange(v: DateValue | undefined) {
    if (v) {
      onValueChange(v);
      open = false;
    }
  }
</script>

<Popover.Root bind:open>
  <Popover.Trigger>
    {#snippet child({ props })}
      <Button
        {...props}
        variant="outline"
        class={cn(
          'qs-datepicker flex min-h-[42px] w-full min-w-[130px] flex-row items-center gap-2 px-2.5 py-1.5 text-left text-sm font-normal',
        )}
      >
        <span class="qs-datepicker-label shrink-0 text-[11px] font-medium text-primary"
          >{label}</span
        >
        <span
          class="qs-datepicker-value flex min-w-0 flex-1 items-center justify-between gap-1.5"
        >
          <span class="qs-datepicker-date font-medium whitespace-nowrap"
            >{formatDate(value, locale)}</span
          >
          <CalendarIcon class="qs-datepicker-icon h-3.5 w-3.5 shrink-0 text-primary" />
        </span>
      </Button>
    {/snippet}
  </Popover.Trigger>
  <Popover.Content
    class="qs-datepicker-popover w-auto p-0"
    align="start"
    portalProps={portalTarget ? { to: portalTarget } : undefined}
  >
    <Calendar
      type="single"
      {value}
      onValueChange={handleChange}
      {minValue}
      {locale}
    />
  </Popover.Content>
</Popover.Root>
